// Libs
import React, { Component } from 'react'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import DashboardPill from '../DashboardPill'
import DashboardTitle from '../DashboardTitle'

class DashboardBar extends Component {
  state = {
    option: { label: 'TOTAL', value: 'total' },
    numberOfRows: 5
  }

  changeOrderBY = (value) => {
    this.setState({ orderBy: value })
  }

  fetchArchiveReasons = (data) => {
    let mainReason
    let maxWidth = 80;
    let archiveReasons = []
    let totalReasons = 0

    data = _.orderBy(data, ["total", "description"], ["desc", "desc"])
    mainReason = data[0].total

    data.map(item => {
      totalReasons = totalReasons + item.total
    })

    for (let i = 0; i < data.length; i++) {
      let width = 0
      let percentage = 0
      let opacity

      if (mainReason !== 0) {
        width = (data[i].total * maxWidth) / mainReason
      }

      if (totalReasons !== 0) {
        percentage = Math.round((data[i].total / totalReasons) * 100)
      }

      width = Math.round(width)

      let numberWidth = 100 - width
      data[i].total / mainReason > 0.2 ? opacity = data[i].total / mainReason : opacity = 0.2

      archiveReasons.push({ "name": data[i].description, "total": data[i].total, width, opacity, numberWidth, percentage })
    }
    return archiveReasons
  }

  componentDidUpdate(prevProps, prevState) {
    const { numberOfRows } = this.state
    const { numberOfRows: prevNumberOfRows } = prevState

    if (numberOfRows != prevNumberOfRows) {
      this.scrollToBottom()
    }
  }

  scrollToBottom() {
    this.el.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    const { data } = this.props
    const { option, numberOfRows } = this.state
    const options = [
      { label: 'TOTAL', value: 'total' },
      { label: 'PORCENTAGEM', value: 'percentage' }
    ]
    let archiveReasons = data

    if (!_.isEmpty(data)) {
      archiveReasons = this.fetchArchiveReasons(data)
    }

    return (
      <div className="dashboard-bar" ref={el => { this.el = el }}>
        <div className="dashboard-bar__header">
          <DashboardTitle title="MOTIVOS SEM SUCESSO" subTitle={option.label} />
          <DashboardPill
            option={option}
            options={options}
            onClick={option => this.setState({ option })} />
        </div>
        <div className="dashboard-bar__column">
          {
            archiveReasons.slice(0, numberOfRows).map(item => {
              return (
                <div key={item.name} className="dashboard-bar__row">
                  <span>
                    <p>{item.name}</p>
                  </span>
                  <div className="dashboard-bar__row-bar" >
                    <div style={{ width: `${item.width}%`, opacity: item.opacity }}></div>
                    <p style={{ marginLeft: item.width === 0 && '0' }}>{option.value === "total" ? item.total : `${item.percentage}%`}</p>
                  </div>
                </div>
              )
            })
          }
          <div className="dashboard-bar__more-info" onClick={() => numberOfRows > 5 ? this.setState({ numberOfRows: 5 }) : this.setState({ numberOfRows: archiveReasons.length })}>{numberOfRows > 5 ? "VER MENOS" : "VER MAIS"}</div>
        </div>
      </div>
    )
  }

}

export default DashboardBar
